module.exports = __webpack_public_path__ + "static/media/tmdb_logo.30cd724b.svg";